var moduleMap = {
	"./Notes": () => {
		return Promise.all([__webpack_require__.e(16492), __webpack_require__.e(98283), __webpack_require__.e(68433)]).then(() => (() => ((__webpack_require__(68433)))));
	},
	"./Teacher": () => {
		return Promise.all([__webpack_require__.e(16492), __webpack_require__.e(47937), __webpack_require__.e(94655), __webpack_require__.e(98283), __webpack_require__.e(89205), __webpack_require__.e(66040), __webpack_require__.e(22511)]).then(() => (() => ((__webpack_require__(52246)))));
	},
	"./SlideNotes": () => {
		return Promise.all([__webpack_require__.e(16492), __webpack_require__.e(47937), __webpack_require__.e(71798), __webpack_require__.e(98283), __webpack_require__.e(89205), __webpack_require__.e(66040), __webpack_require__.e(77629)]).then(() => (() => ((__webpack_require__(77629)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});